import { DataTableBodyCellBadge, DataTableBodyCellDate, DataTableBodyCellGender, TableCellEmpty, TableCellRowLine } from '@/components/custom';
import DataTableBodyCellPaymentInfoDetails from './DataTableBodyCellPaymentInfoDetails';
import DataTableBodyCellPaymentInfoMethod from './DataTableBodyCellPaymentInfoMethod';
import DataTableBodyCellOptions from './DataTableBodyCellOptions';
import { TableBody, TableCell, TableRow } from '@/components/ui';
import DataTableBodyCellType from './DataTableBodyCellType';
import { useCreators } from '../../hooks';

export const DataTableBody = () => {

  const { creators, edit } = useCreators();

  return (
    <TableBody>
      {
        [...creators]
          .map(
            (creator, index) => (
              <TableRow
                key={creator._id}
                onClick={() => edit({ creator })}
                className='cursor-pointer'>
                <TableCellRowLine value={index + 1} />
                <DataTableBodyCellGender gender={creator.gender} />
                <DataTableBodyCellType creator={creator} />
                <DataTableBodyCellBadge
                  title={`(${creator.referralCount}) parrainé(s)`}
                  children={creator.referralCount}
                  className='text-center' />
                <TableCell
                  title={creator.username}
                  className='py-1 pe-0 w-0 max-w-[200px] truncate whitespace-nowrap overflow-hidden font-semibold'>
                  {creator.username}
                </TableCell>
                <TableCell
                  className='py-1 pe-0 w-28 text-purple-600 font-semibold'>
                  {
                    creator.referralCode
                      ? creator.referralCode
                      : <TableCellEmpty text='Non défini' />
                  }
                </TableCell>
                <TableCell
                  className='py-1 pe-0 w-16 text-purple-600 text-center font-semibold'>
                  {creator.coinsAmount}
                </TableCell>
                <TableCell
                  title={`(${creator.links.length}) lien(s)`}
                  className='py-1 pe-0 w-0 text-purple-600 text-center font-semibold'>
                  {creator.links.length}
                </TableCell>
                <DataTableBodyCellPaymentInfoMethod creator={creator} />
                <DataTableBodyCellPaymentInfoDetails paymentInfo={creator.paymentInfo} />
                <DataTableBodyCellDate date={creator.createdAt} />
                <DataTableBodyCellOptions creator={creator} />
              </TableRow>
            )
          )
      }
    </TableBody>
  );

};

export default DataTableBody;
